module.exports = __webpack_public_path__ + "img/Borealis.03beea8d.jpg";